module.exports = __webpack_public_path__ + "media/images/covid/icons/distance-63417dac1b425d78a09e59206097ec4f.svg";